import { jsx as _jsx } from "react/jsx-runtime";
import { Tag, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const ItemCounterBar = ({ itemType, itemCount, onClear, }) => {
    if (itemCount === null) {
        return null;
    }
    return (_jsx(Tag, { closable: true, onClose: onClear, className: styles.countTag, closeIcon: (_jsx(Tooltip, { title: itemType === 'filtered' ? txt('clearFilter') : txt('deselectAll'), children: _jsx(CloseOutlined, {}) })), children: `${itemType === 'filtered' ? txt('filtered') : txt('selected')}: ${itemCount}` }));
};
export default ItemCounterBar;
